import script from "./collectionNewEntery.vue?vue&type=script&setup=true&lang=js"
export * from "./collectionNewEntery.vue?vue&type=script&setup=true&lang=js"

import "./collectionNewEntery.vue?vue&type=style&index=0&id=3f66d587&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f66d587"]])

export default __exports__